interface ApiConfigurationBase {
  baseUrl?: string;
  headers?: (() => object) | (() => Promise<object>);
}

// OpenApi
interface ApiConfigurationOpenApi extends ApiConfigurationBase {
  onRequest?: (() => void) | (() => Promise<void>);
  onResponse?: ((response: Response) => void) | ((response: Response) => Promise<void>);
}

export type ConfigureOpenApi = (options: ApiConfigurationOpenApi) => void;

export class ApiConfigurationManagerOpenApi {
  #config: ApiConfigurationOpenApi = {};

  set config(config: ApiConfigurationOpenApi) {
    this.#config = { ...this.#config, ...config };
  }

  get config() {
    return this.#config;
  }
}

// GraphQL
interface ApiConfigurationGraphql<TResponse> extends ApiConfigurationBase {
  onRequest?: ((query: string) => void) | ((query: string) => Promise<void>);
  onResponse?: ((response: TResponse, query: string) => void) | ((response: TResponse, query: string) => Promise<void>);
}

export type ConfigureGraphql<TResponse> = (options: ApiConfigurationGraphql<TResponse>) => void;

export class ApiConfigurationManagerGraphql<TResponse> {
  #config: ApiConfigurationGraphql<TResponse> = {};

  set config(config: ApiConfigurationGraphql<TResponse>) {
    this.#config = { ...this.#config, ...config };
  }

  get config() {
    return this.#config;
  }
}
